import React from 'react'
import Switch from '../Switch/Switch'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
//import I18n from "i18n-js/index.js.erb"

export default class ReservationSegmentCancelWarning extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div>
        <div className="row">
          <div className="col-sm-12">
            <div style={{color: 'red', fontWeight: 'bold'}}>{I18n.t('custom_cancellation_rule_warning')}</div>
          </div>
          {/* <div>{this.props.custom_rule}</div> */}
        </div>
        <br />
        <div className="row">
          <div className="col-sm-12">
            {this.props.custom_rule}
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-sm-6">
            <label >{I18n.t('cancel_room')}?</label>
            <Switch onText="yes" switchId="on-cancel-warning" offText="no" value={this.props.cancel_warning} onChange={this.props.onChangeCancelWarning} />
          </div>
        </div>
        <LoadingSpinner show={this.props.loading} />
      </div>
    );

  }
}
